/*
 * @Author: 'Lizz' lzz1961690348@163.com
 * @Date: 2023-05-06 14:25:45
 * @LastEditors: The_xu 2596841393@qq.com
 * @LastEditTime: 2025-09-10 10:31:40
 * @FilePath: \yda-qywx-h5\src\store\diyform.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from "pinia";

export const useStoreDiyForm = defineStore("diyForm", {
  state: () => ({
    processId: null, // 业务单据编码
    processDefinitionId: null, // 业务流程定义ID
    recordId: null, // 重新提交记录ID
    formItems: [],
    form: {},
    sealFormData: {
      formRef: undefined,
      sealList: [
        [
          {
            id: "applySeal0",
            title: "申请印章",
            controlName: "SelectInput",
            value: "",
            valueType: "String",
            props: {
              required: true,
              enablePrint: true,
              expanding: false,
              options: ["印章1", "印章2"],
            },
          },
          {
            id: "applyNum0",
            title: "申请次数",
            controlName: "NumberInput",
            value: "",
            valueType: "String",
            props: {
              required: true,
              enablePrint: true,
            },
          },
          {
            id: "sealer0",
            title: "盖印人",
            controlName: "SelectInput",
            value: "",
            valueType: "String",
            props: {
              required: true,
              options: ["申请人", "保管员"],
            },
          },
        ],
      ],
      sealAllList: [], // 印章
      forms: [
        {
          sealId: "",
          applicationNumber: "",
          affixedType: "",
        },
      ],
      rules: null,
      keeperObj: {}, // 所有保管员列表
      sealerList: [], //盖印人选项列表
      defaultType: 2, //盖印人默认选中
    },
    isqueryResubmit: false,
    deactivateSealIdList: [],
    qrcodeForm: {
      //二维码水印配置参数
    },
    convertedPdfData: null
  }),
  actions: {
    // 同步整体控件数组
    setFomrItems(list) {
      console.log(list, "ssss");
      this.formItems = list;
      this.setForm(list);
    },
    // 同步表单数据
    setForm(list) {
      let obj = {};
      list.forEach((element) => {
        obj[element.id] = undefined;
      });
      this.form = { ...obj, ...this.form };
    },
    // 同步所需ID
    setNeedId(processId, processDefinitionId) {
      this.processDefinitionId = processDefinitionId;
      this.processId = processId;
    },
    // 同步重新提交所需ID
    setResubmitId(id) {
      this.recordId = id;
    },
    // 重新提交-回显数据-回填到form
    setResubmitDataEcho(obj) {
      this.form = { ...this.form, ...obj };
    },
    // 设置是否查询过重新提交接口
    setIsQueryResubmit(val) {
      this.isqueryResubmit = val;
    },
    // 设置停用的印章ID
    setDeactivateSealIdList(val) {
      this.deactivateSealIdList = val;
    },
    //设置二维码水印参数
    setQrcodeConfig(val) {
      this.qrcodeForm = val;
    },

    // 添加设置转换后PDF数据的方法
    setConvertedPdfData(data) {
      this.convertedPdfData = data
    },
    // 清除数据的方法
    clearConvertedPdfData() {
      this.convertedPdfData = null
    }
  },
});
